import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

import { getMonthNameFromString } from 'utils/helpers';

/** Início do modelo de fases mensais nomeadas (10/03/2025). */
const INICIO_FASES_MENSAIS = 1741575600000;
/** Fim do modelo em que `faseTitle` já é o rótulo final (31/08/2024). */
const FIM_FASES_ANTIGAS = 1725159599999;

/**
 * Rótulo da fase de uma realização. Regra que morava no PointItem; sai para cá
 * para o gráfico "Pontos por fase" agrupar pela mesma fase que o cartão mostra.
 */
export function faseDoItem(item: any): string {
  if (item.time >= INICIO_FASES_MENSAIS) {
    if (item.faseTitle) {
      return getMonthNameFromString(item.faseTitle);
    }

    return format(new Date(item.task_time ?? item.task?.created ?? null), 'MMMM', { locale: ptBR });
  }

  if (item.time <= FIM_FASES_ANTIGAS || item.period === '1_mensal') return item.faseTitle;

  const name = item.period === '2_trimestral' ? 'Nível 2 -' : 'Nível 3 -';
  const month = format(new Date(item.task_time), 'MMMM', { locale: ptBR });

  return `${name} ${month}`;
}
